import { SuscripcionService } from 'src/app/shared/services/suscripcion.service';
import { Component } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { KeycloakService } from 'keycloak-angular';
import { Elemento } from 'src/app/shared/models/elemento.model';
import { ElementoFiltro } from 'src/app/shared/models/elementoFiltro.model';
import { ElementService } from 'src/app/shared/services/element.service';
import { environment } from 'src/environments/environment';
import { PartnerDialogComponent } from '../component/partner-dialog/partner-dialog.component';
import { Categoria } from 'src/app/shared/models/categoria.model';
import { CategoriasService } from 'src/app/shared/services/categorias.service';
import { map } from 'rxjs';

@Component({
  selector: 'app-empresas',
  templateUrl: './empresas.component.html',
  styleUrls: ['./empresas.component.scss'],
})
export class EmpresasComponent {
  constructor(
    private elementService: ElementService,
    private modalService: NgbModal,
    private keycloakService: KeycloakService,
    private suscripcionService: SuscripcionService,
    private categoriasService: CategoriasService,
  ) {
    this.keycloakService.loadUserProfile().then(u => {
      this.user = u;
      this.checkLoginStatus();
    });
  }

  img_base = environment.img_base;

  pageIndex = 0;
  desplazamiento = 0;
  limite = 1000;
  totalItems = 0;

  elementos$: Elemento[] = [];
  isMobileWidth = false;
  esSuscriptor: boolean = false;

  odsList: Categoria[] = [];
  etapaList: Categoria[] = [];
  dimensionList: Categoria[] = [];
  isFirstLoad: boolean = true;

  ngOnInit() {
    this.suscripcionService.isSuscriptor().subscribe(result => {
      this.esSuscriptor = result;
    });

    this.categoriasService.getAll().subscribe((result: any) => {
      this.odsList = result.categorias.filter(
        (cat: Categoria) => cat.tipo_clasificacion === 'ods',
      )[0].categorias;
      this.dimensionList = result.categorias.filter(
        (cat: Categoria) => cat.tipo_clasificacion === 'dimension',
      )[0].categorias;
      this.etapaList = result.categorias.filter(
        (cat: Categoria) => cat.tipo_clasificacion === 'etapa',
      )[0].categorias;
    });

    this.filtro.patchValue({
      nombre: '',
      dimension: '0',
    });

    this.filtrar(false);
  }

  isLoggedIn = false;
  public user!: Keycloak.KeycloakProfile;

  async checkLoginStatus() {
    this.isLoggedIn = await this.keycloakService.isLoggedIn();
  }

  public filtro = new FormGroup({
    nombre: new FormControl(),
    dimension: new FormControl(),
  });

  public async filtrar(cargarMas: boolean): Promise<void> {
    this.pageIndex++;
    this.desplazamiento = this.pageIndex * this.limite;
    if (!cargarMas) {
      this.pageIndex = 0;
      this.desplazamiento = 0;
    }
    var filtroParticipantes: ElementoFiltro = new ElementoFiltro();
    filtroParticipantes.rolMinimo = 1;
    filtroParticipantes.estado = 'ACTIVO';
    filtroParticipantes.modulo = 'Empresas';
    filtroParticipantes.nombre = this.filtro.controls['nombre'].value;
    // const dimension = this.filtro.controls['dimension'].value;
    // filtroParticipantes.categorias = dimension > 0 ? [dimension] : [];

    this.elementService
      .getAll(
        this.limite,
        this.desplazamiento,
        filtroParticipantes,
        'nombre-asc',
      )
      .pipe(
        map(data => ({
          total: data.total,
          elementos: data.elementos.filter(
            elem =>
              !['empresa de comunidades'].includes(
                elem?.tipoModulo?.nombre?.toLowerCase().trim(),
              ),
          ),
        })),
      )
      .subscribe(data => {
        if (cargarMas) {
          this.elementos$ = [...this.elementos$, ...data.elementos];
        } else {
          this.elementos$ = data.elementos;
          if (!this.isFirstLoad) {
            const elementToScroll = document.querySelector('.filters-section');
            elementToScroll?.scrollIntoView({
              behavior: 'smooth',
              block: 'start',
            });
          }
          this.isFirstLoad = false;
        }
        this.totalItems = data.total;
      });
  }

  public resetear(): void {
    this.filtro.reset({
      nombre: '',
      dimension: '0',
    });
    this.filtrar(false);
  }

  public loadMore() {
    this.desplazamiento = this.pageIndex * this.limite;
    this.filtrar(true);
  }

  openModal(id: number) {
    const modalRef = this.modalService.open(PartnerDialogComponent, {
      centered: true,
      size: 'lg',
      modalDialogClass: 'person--dialog',
    });
    modalRef.componentInstance.id = id;
  }
}
